import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Navigation } from 'app/configuration/navigation/navigation.types';
import { cloneDeep, lowerFirst } from 'lodash';
import { ApiService } from '@core/services/api';
import { manageStorageService } from '@core/services/manage-storage/manage-storage.service';


@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _api: ApiService, private _mStorage: manageStorageService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }


    // -----------------------------------------------------------------------------------------------------
    // @ private  methods
    // -----------------------------------------------------------------------------------------------------
    private managementMenu(getMenu:any) {
        return new Promise<any>((rslvMenu, rjctMenu) => {
            
            let _horizontalNavigation = getMenu.horizontal,
                _defaultNavigation = getMenu.default,
                role = this._mStorage.getPropertie('s_userSession')?.rol;

            switch (role) {
                case '0':
                    _horizontalNavigation.shift();
                    _defaultNavigation.shift();
                    break;
                case '1':
                    _horizontalNavigation[0].children.shift();
                    _defaultNavigation[0].children.shift();
                break;
            }



            rslvMenu({
                default: cloneDeep(_defaultNavigation),
                horizontal: cloneDeep(_horizontalNavigation)
            })

            rjctMenu({})
        })

    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        return this._httpClient.get<Navigation>('api/common/navigation').pipe(
            tap((allMenu) => {

                // Store the navigation in the service  
                // this._navigation.next(respMenu)
                this.managementMenu(allMenu).then((respMenu) => { this._navigation.next(respMenu); })

            })
        );
    }
}
